import { render } from "./TabOrderDetail.vue?vue&type=template&id=00df99fb"
import script from "./TabOrderDetail.js?vue&type=script&lang=js"
export * from "./TabOrderDetail.js?vue&type=script&lang=js"

import "./TabOrderDetail.scss?vue&type=style&index=0&lang=scss"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__